module.exports = __webpack_public_path__ + "static/media/pag-QueroSerLojista-ebit-03.5f22c321.5f22c321.png";